import { css } from 'styled-components'

const TEXT_TYPES = {
  primary: css`
    color: var(--text-color-primary);
  `,
  accent: css`
    color: var(--text-color-accent);
  `,
  secondary: css`
    color: var(--text-color-secondary);
  `,
  black: css`
    color: var(--text-color-black);
  `,
  white: css`
    color: var(--text-color-white);
  `,
  danger: css`
    color: var(--text-color-danger);
  `,
  warning: css`
    color: var(--text-color-warning);
  `,
  default: css`
    color: var(--text-color-white);
  `
}

export default TEXT_TYPES
